// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__2Lhg0","icon":"FeatureCard_icon__gvH6B","title":"FeatureCard_title__UUn1h","description":"FeatureCard_description__JBNOl"};